(ns nl.mediquest.be-my-coach-frontend.views
  (:require
   [nl.mediquest.be-my-coach-frontend.views.filters :as filters]
   [nl.mediquest.be-my-coach-frontend.views.map :as map]
   [nl.mediquest.be-my-coach-frontend.views.zorgverleners :as zorgverleners]))

(def ^:private title
  [:div.text-white.text-3xl.text-center.font-bold.px-6.py-6
   "Sociale" \u202F "kaart"])

(defn- header
  []
  [:div.h-20.w-full.flex.justify-between.bg-bmc-secondary
   [:div.flex.h-20
    [:a.h-full.py-4.px-6 {:href "https://www.be-my-coach.nl"}
     [:img.h-full {:src "/images/Be_My_Coach_logo_1.svg"}]]
    [:div.w-1.h-16.mt-2.bg-white]
    title]
   [filters/postal-code-input]])

(defn- footer
  []
  [:div.h-10.w-full.flex.bg-bmc-secondary.text-white.justify-center.space-x-8.py-2
   [:span
    "Wil je ook op deze sociale kaart staan of heb je een foutje gezien? Neem contact met ons op!"]
   [:a {:href "tel:+31488417400"}
    [:i.fa.fa-phone.mr-1.p-1.bg-white.text-bmc-secondary.rounded-full]
    "+31 488 417 400"]
   [:a {:href "mailto:info@be-my-coach.nl"}
    [:i.fa.fa-envelope.mr-1.p-1.bg-white.text-bmc-secondary.rounded-full]
    "info@be-my-coach.nl"]])

(defn main-panel
  []
  [:div.h-screen.flex.flex-col.rows-3
   [header]
   [:div.flex-auto.flex
    [:div
     {:class ["flex-[2]"]}
     [filters/filter-panel]]
    [:div
     {:class ["flex-[3]"]}
     [zorgverleners/view]]
    [:div
     {:class ["flex-[6]"]}
     [map/view]]]
   [footer]])
